import React from "react";
import { Box, Text, PseudoBox, Flex, Image } from "@chakra-ui/core";

const FoodCard = (props) => {
  if (props.size === "md" || props.size === "lg") {
    return (
      <PseudoBox
        borderWidth="2px"
        rounded="lg"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        alignItems="top"
        // verticalAlign="baseline"
        bg={props.isAvailable ? "white" : "gray.100"}
        justifyContent="space-between"
        borderColor={props.amountInBasket > 0 ? "green.300" : "gray.200"}
        _hover={{
          bg: props.isAvailable ? "brand.50" : "gray.100",
          borderColor: props.amountInBasket > 0 ? "green.400" : "brand.400",
          cursor: "pointer",
        }}
        transition="all 200ms cubic-bezier(0.4, 0, 0.2, 1)"
        minH="130px"
        position="relative"
        onClick={props.onClick}
      >
        {props.badgeText && (
          <Flex
            position="absolute"
            top={1}
            left={1}
            py={0}
            px={2}
            bg="orange.300"
            rounded="md"
            zIndex="10"
            align="center"
            justify="center"
            shadow="sm"
          >
            <Text fontSize="sm" textTransform="uppercase" color="white" fontWeight={600}>
              {props.badgeText}
            </Text>
          </Flex>
        )}
        {props.amountInBasket > 0 && (
          <Flex
            position="absolute"
            top="0"
            right="0"
            h="8"
            w="8"
            bg="green.300"
            borderTopRightRadius="0.4rem"
            borderBottomLeftRadius="lg"
            zIndex="10"
            align="center"
            justify="center"
          >
            <Text fontSize="md" color="white" fontWeight="bold">
              {props.amountInBasket}
            </Text>
          </Flex>
        )}
        {props.image ? (
          // <Box
          //   mb={8}
          //   bgImage={`url(${props.image})`}
          //   bgPos="center"
          //   bgSize="contain"
          //   bgRepeat="no-repeat"
          //   rounded="2xl"
          //   w="full"
          //   h="auto"
          //   pos="relative"
          //   flexShrink="0"
          // />
          <Image src={props.image} fallbackSrc="/images/fallback-image.jpg" h="auto" w="full" objectFit="contain" />
        ) : null}
        <Box
          flexGrow="1"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          textAlign="center"
          px={4}
          py={4}
        >
          <Box>
            <Text
              fontWeight="700"
              fontFamily="heading"
              fontSize="md"
              textTransform="uppercase"
              color={props.isAvailable ? "gray.800" : "gray.400"}
            >
              {props.name}
            </Text>
            {/* <Text pt="1" className="truncatedText" color="gray.500">
              {props.description}
            </Text> */}
          </Box>
          {props.price && (
            <Box>
              <Text pt="1" fontWeight="700" fontSize="md" color={props.isAvailable ? "gray.700" : "gray.400"}>
                {props.price}
              </Text>
            </Box>
          )}
        </Box>
      </PseudoBox>
    );
  } else {
    return (
      <PseudoBox
        borderWidth="2px"
        rounded="lg"
        overflow="hidden"
        display="flex"
        alignItems="top"
        verticalAlign="baseline"
        bg={props.isAvailable ? "white" : "gray.100"}
        p="4"
        justifyContent="space-between"
        borderColor={props.amountInBasket > 0 ? "green.300" : "gray.200"}
        _hover={{
          borderColor: props.amountInBasket > 0 ? "green.400" : "gray.800",
          cursor: "pointer",
        }}
        transition="all 200ms cubic-bezier(0.4, 0, 0.2, 1)"
        minH="130px"
        position="relative"
        onClick={props.onClick}
      >
        {props.amountInBasket > 0 && (
          <Flex
            position="absolute"
            top="0"
            right="0"
            h="8"
            w="8"
            bg="green.300"
            borderTopRightRadius="0.4rem"
            borderBottomLeftRadius="lg"
            zIndex="10"
            align="center"
            justify="center"
          >
            <Text fontSize="md" color="white" fontWeight="bold">
              {props.amountInBasket}
            </Text>
          </Flex>
        )}
        <Box flexGrow="0" display="flex" justifyContent="space-between" alignItems="flex-start" flexDirection="column">
          <Box>
            <Text pb="1" fontWeight="500" fontSize="md">
              {props.name}
            </Text>
            <Text className="truncatedText" color="gray.500">
              {props.description}
            </Text>
          </Box>
          {props.price && (
            <Box>
              <Text pt="1" fontWeight="500" fontSize="sm" color="gray.700">
                {props.price}
              </Text>
            </Box>
          )}
        </Box>
        {props.image ? (
          <Box
            ml="2"
            bgImage={`url(${props.image})`}
            bgPos="center"
            bgSize="cover"
            bgRepeat="no-repeat"
            rounded="md"
            w="24"
            h="24"
            pos="relative"
            flexShrink="0"
          />
        ) : null}
      </PseudoBox>
    );
  }
};

export default FoodCard;
